// Generated from SVG to Code Figma Plugin

export const EarnCreditsIcon = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 19 18" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M16.123 5.625H3.74805C3.43739 5.625 3.18555 5.87684 3.18555 6.1875V8.4375C3.18555 8.74816 3.43739 9 3.74805 9H16.123C16.4337 9 16.6855 8.74816 16.6855 8.4375V6.1875C16.6855 5.87684 16.4337 5.625 16.123 5.625Z"
      stroke="#009BFF"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.125"
    />
    <path
      d="M15.5605 9V14.8125C15.5605 14.9617 15.5013 15.1048 15.3958 15.2102C15.2903 15.3157 15.1472 15.375 14.998 15.375H4.87305C4.72386 15.375 4.58079 15.3157 4.4753 15.2102C4.36981 15.1048 4.31055 14.9617 4.31055 14.8125V9"
      stroke="url(#paint0_linear_9756_4005)"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.125"
    />
    <path
      d="M9.93555 5.625V15.375"
      stroke="url(#paint1_linear_9756_4005)"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.125"
    />
    <path
      d="M13.3661 2.19464C14.0228 2.85136 14.0615 3.95668 13.3661 4.57261C12.1771 5.62519 9.93555 5.62519 9.93555 5.62519C9.93555 5.62519 9.93555 3.38363 10.9902 2.19464C11.6041 1.49925 12.7094 1.53793 13.3661 2.19464Z"
      stroke="url(#paint2_linear_9756_4005)"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.125"
    />
    <path
      d="M6.50519 2.19464C5.84847 2.85136 5.8098 3.95668 6.50519 4.57261C7.69418 5.62519 9.93574 5.62519 9.93574 5.62519C9.93574 5.62519 9.93574 3.38363 8.88105 2.19464C8.26722 1.49925 7.16191 1.53793 6.50519 2.19464Z"
      stroke="url(#paint3_linear_9756_4005)"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.125"
    />
    <defs>
      <linearGradient
        id="paint0_linear_9756_4005"
        gradientUnits="userSpaceOnUse"
        x1="9.93555"
        x2="9.93555"
        y1="9"
        y2="15.375"
      >
        <stop stopColor="#009BFF" />
        <stop offset="1" stopColor="#5CD0FF" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_9756_4005"
        gradientUnits="userSpaceOnUse"
        x1="10.4355"
        x2="10.4355"
        y1="5.625"
        y2="15.375"
      >
        <stop stopColor="#009BFF" />
        <stop offset="1" stopColor="#5CD0FF" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_9756_4005"
        gradientUnits="userSpaceOnUse"
        x1="11.9044"
        x2="11.9044"
        y1="1.6875"
        y2="5.62519"
      >
        <stop stopColor="#009BFF" />
        <stop offset="1" stopColor="#5CD0FF" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_9756_4005"
        gradientUnits="userSpaceOnUse"
        x1="7.96689"
        x2="7.96689"
        y1="1.6875"
        y2="5.62519"
      >
        <stop stopColor="#009BFF" />
        <stop offset="1" stopColor="#5CD0FF" />
      </linearGradient>
    </defs>
  </svg>
);
